module.exports = __webpack_public_path__ + "45c14be8bbfc03c61dfc9d344ebee4e1.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular-Oblique.woff
// module id = 384
// module chunks = 0